<h1 mat-dialog-title *ngIf="title">{{ title }}</h1>
<button test-id="modal-close-button" mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<div style="width: 90vw; overflow: hidden;">
  <div *ngIf="isLoading" class="loading">
    <mat-spinner diameter="40"></mat-spinner>
    <span>{{ 'common.labels.loading' | translate }}</span>
  </div>
  <pre *ngIf="text" style="height: 80vh;">{{ text }}</pre>
</div>
